module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if (mode == "foreign" || value.emergency) { 
    ; __append("\n")
    ;  if (!value.emergency && typeof(native) == "object" && native.emergency) { 
    ; __append("\n\n")
    ;  if (!value.emergency) { 
    ; __append("\n<s>\n")
    ;  } 
    ; __append("\n\n	<b>ЧРЕЗВЫЧАЙНАЯ СИТУАЦИЯ</b>\n\n")
    ;  if (!value.emergency) { 
    ; __append("\n</s>\n")
    ;  } 
    ; __append("\n\n")
    ;  } 
    ; __append("\n")
    ;  } 
  }
  return __output.join("");

}